import './App.css';
import Layout from './Layout/Layout';
import Routing from './Layout/Routing';

function App() {
  return (
    <>
      <Layout>
        <Routing />
      </Layout>
    </>
  );
}

export default App;
